<style lang="scss">
  @import "@/assets/scss/vuexy/components/principalMenuItem.scss";
</style>
<style lang="scss" scoped>
  .vx-card {
    height: 320px;
  }
</style>
<template>
  <vs-button class="p-0 h-full" type="line" :to="{ path: route }">
    <vx-card class="grid-view-item  overflow-hidden h-full">
      <div class="verticle-image-container h-full">
        <img :src="getImgUrl(img)" class="spore-login-logo" alt="logo spore">
        <span class="verticle-title">{{title}}</span>
        <span class="verticle-description">{{description}}</span>
      </div>
    </vx-card>
  </vs-button>
</template>
<script>
export default {
  props: {
    route: String,
    img: String,
    title: String,
    description: String
  },
  methods: {
    getImgUrl (name) {
      const images = require.context('@/assets/images/menu/', false, /\.svg$/)
      return images(`./${name}.svg`)
    }
  }
}
</script>
